import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ReceiptVerificationRequest } from '../models/receipt-verification-request.model';

@Injectable({
  providedIn: 'root',
})
export class VerifyReceiptService {
  constructor(private http: HttpClient) {}

  lFN_GetReceiptList(payload: ReceiptVerificationRequest) {
    return this.http.post(
      `${environment.ROOT_URL}/jsyogaccounts/receiptVerification`,
      payload,
      {
        withCredentials: true,
        observe: 'response',
        responseType: 'text',
      }
    );
  }

  lFN_MarkVerified(
    accountsheaderId: number,
    bookNo: number,
    receiptNo: number
  ) {
    const url = `${environment.ROOT_URL}/jsyogaccounts/markVerified/accountsheaderId/${accountsheaderId}/bookNo/${bookNo}/receiptNo/${receiptNo}`;

    return this.http.patch(
      url,
      {},
      {
        withCredentials: true,
        observe: 'response',
        responseType: 'text',
      }
    );
  }
}
